import {RouteLocationRaw} from 'vue-router'

/**
 * A página de uma propriedade — editar a gravada, ou criar uma na coleção —, para onde o Expandir da
 * janela leva (pedido do usuário). Como o `instanceLink` é do item.
 */
export function propertyRoute(system: string, idea: string, property?: string): RouteLocationRaw {
    return property
        ? {name: 'edit-property', params: {system, idea, property}}
        : {name: 'create-property', params: {system, idea}}
}

/** A chave da entrega da janela à página (`handOver`): a propriedade, ou a nova da coleção. */
export function propertyKey(system: string, idea: string, property?: string): string {
    return `property:${system}/${idea}/${property || ''}`
}
